<div class="maintenance-pages">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-xl-12 align-self-center">
        <router-outlet />
      </div>
    </div>
  </div>
</div>
